export default __webpack_public_path__ + "static/media/commonsplace-short-logo.29978fd2.png";